import { myAxios } from "./axios";

export function getLeads(payload, { page, limit }) {
    let config = {
        params: {
            page,
            limit,
            ...(payload || {}),
        },
    };
    return myAxios.get("/leads", config);
}

export function getLead(id) {
    return myAxios.get("/leads/" + id);
}

export function addLead(data) {
    return myAxios.post("/leads/add", data);
}

export function editLead(id, data) {
    return myAxios.put(`/leads/edit/${id}`, data);
}

export function deleteLead(id) {
    return myAxios.delete("/leads/" + id);
}
